import {useEffect, useRef} from "react";

// register a keydown handler for the elevation menubar's canvas shortcuts (clear
// selection, delete the selected element, etc). The field-focus guard is applied
// here so callers don't repeat it: keystrokes while typing in an input / textarea
// / contentEditable are ignored, letting the key do its normal thing there.
//
// Each contextual "Selected XX" tab registers its own delete hotkey through this,
// so the shortcut lives next to the matching ribbon action. The handler is kept in
// a ref so passing a fresh inline closure each render doesn't churn the window
// listener.
export function useMenubarKeyPress(handler: (e: KeyboardEvent) => void) {
    const ref = useRef(handler);
    ref.current = handler;

    useEffect(() => {
        const listener = (e: KeyboardEvent) => {
            const el = e.target as HTMLElement | null;
            const tag = el?.tagName;
            if(tag === "INPUT" || tag === "TEXTAREA" || el?.isContentEditable) return;
            ref.current(e);
        };

        window.addEventListener("keydown", listener);
        return () => window.removeEventListener("keydown", listener);
    }, []);
}
